import { Menu } from '@headlessui/react';

import WorkspaceItem from './WorkspaceItem/WorkspaceItem';
import useWorkspacesContext from '../WorkspacesProvider/useWorkspacesContext';

type WorkspacesListProps = {
  workspaces: string[];
  selectedId: string | null;
  selectWorkspace?: (id: string) => void;
  initiallyExpandedDepth?: number;
  hasMemberCount?: boolean;
  expandSelectedPath?: boolean;
};

const WorkspacesList = ({
  workspaces,
  selectedId,
  selectWorkspace,
  initiallyExpandedDepth,
  hasMemberCount,
  expandSelectedPath,
}: WorkspacesListProps) => {
  const { workspacesState } = useWorkspacesContext();

  return (
    <Menu>
      {workspaces.map((id: string) => {
        const workspace = workspacesState.workspaces[id];
        if (!workspace) return null;

        return (
          <Menu.Item as="div" key={id} onClick={(e) => e.preventDefault()}>
            <WorkspaceItem
              workspace={workspace}
              selectedId={selectedId}
              depth={0}
              selectWorkspace={selectWorkspace}
              initiallyExpandedDepth={initiallyExpandedDepth}
              expandSelectedPath={expandSelectedPath}
              hasMemberCount={hasMemberCount}
            />
          </Menu.Item>
        );
      })}
    </Menu>
  );
};

export default WorkspacesList;
